import { render, staticRenderFns } from "./AcademySetup.vue?vue&type=template&id=656ad4f4&scoped=true"
import script from "./AcademySetup.vue?vue&type=script&lang=js"
export * from "./AcademySetup.vue?vue&type=script&lang=js"
import style0 from "./AcademySetup.vue?vue&type=style&index=0&id=656ad4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ad4f4",
  null
  
)

export default component.exports